<template>
  <div>
    <v-layout row wrap justify-center align-center>
      <v-flex xs12 md12 lg12 class="text-xs-center">
          <v-progress-circular
              :size="70"
              :width="7"
              indeterminate
              color="#ff9233"
              class="text-xs-center my-5"
              large
              v-if="submit_loader"
          ></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
    <v-container fluid grid-list-md class="padding_10" v-if="!submit_loader">
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>

      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <v-form
                id="populate_announcement"
                @submit.prevent="validateBeforeSubmit('createAnnouncement')"
                ref="announcement_form"
                v-model="valid"
            >
              <v-card-text>
                <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                  <v-layout row wrap>
                    <v-flex xs12 md8 lg4>
                      <label>Announcement Type</label>
                      <v-autocomplete
                          :items="announcement_types"
                          name="Announcement Type"
                          label="Select Announcement Type"
                          v-model="announcement_object.type"
                          return-object
                          item-text="title"
                          item-value="id"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('createAnnouncement.Announccement Type')"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs6 md8 lg3>
                      <label>Train Code</label>
                      <v-autocomplete
                          :items="train_codes"
                          v-model="announcement_object.train_code"
                          name="Announccement Type"
                          label="Select Train Code"
                          return-object
                          :item-text=getItemText
                          item-value="number"
                          solo flat
                          :disabled="(this.announcement_object.type.id != '1' && this.announcement_object.type.id !=
                          '3' && this.announcement_object.type.id != '5')
                          ? true:false"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs6 md8 lg2 v-if="this.announcement_object.type.id == '3'">
                      <label>Delay Time(mins)</label>
                      <v-text-field
                          name="delay_time"
                          v-model="announcement_object.delay_time"
                          @keydown.space.prevent
                          solo flat
                          :disabled="announcement_object.type.id !== 3"
                      ></v-text-field>
                    </v-flex>

                    <div style="padding-top: 10px;">
                      <v-flex xs6 md8 lg2>
                        <v-btn
                            color="primary"
                            elevation="2"
                            id="start_button"
                            @click="populate_announcement()"
                            :disabled="!is_populate"
                            large
                        >Populate
                        </v-btn>
                      </v-flex>
                    </div>

                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Local Line </label>
                      <v-autocomplete
                          :items="local_lines"
                          name="Local Line"
                          v-model="announcement_object.local_line"
                          return-object
                          item-text="code"
                          item-value="id"
                          label="Select Local Line"
                          filled
                          chips
                          multiple
                          solo flat
                          :disabled="announcement_object.type.id == 1 || announcement_object.type.id==3"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Title </label>
                      <v-text-field
                          name="Title"
                          v-model="announcement_object.title"
                          label="Title"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('createAnnouncement.Title')"
                          clearable
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Description: </label>
                      <v-textarea
                          name="Description"
                          v-model="announcement_object.description"
                          rows="2"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('createAnnouncement.Description')"
                          clearable>
                      </v-textarea>
                    </v-flex>
                  </v-layout>

                  <!--                  <v-layout row wrap style="padding-bottom: 20px;">-->

                  <!--                    <v-flex xs12 md6 lg3 v-if="show_search">-->
                  <!--                      <v-checkbox-->
                  <!--                          v-model="announcement_object.show_in_search"-->
                  <!--                          label="Show in search Trains"-->
                  <!--                          color="rgb(246 97 95)"-->
                  <!--                          hide-details-->
                  <!--                      ></v-checkbox>-->
                  <!--                    </v-flex>-->
                  <!--                    <v-flex xs12 md6 lg3 v-if="announcement_object.show_in_search">-->
                  <!--                      <flat-pickr-->
                  <!--                          class="flatpickerCSS2"-->
                  <!--                          label="Show From"-->
                  <!--                          v-model="announcement_object.show_from"-->
                  <!--                          :config="config"-->
                  <!--                          placeholder="Select Show From"-->
                  <!--                          name="show from"/>-->
                  <!--                    </v-flex>-->
                  <!--                    <v-flex xs12 md6 lg3 v-if="announcement_object.show_in_search">-->
                  <!--                      <flat-pickr-->
                  <!--                          class="flatpickerCSS2"-->
                  <!--                          label="Show Till"-->
                  <!--                          v-model="announcement_object.show_till"-->
                  <!--                          :config="config"-->
                  <!--                          placeholder="Select Show Till"-->
                  <!--                          name="show till"/>-->
                  <!--                    </v-flex>-->
                  <!--                  </v-layout>-->


                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="(announcement_object.description == '' ||
                  announcement_object.type == '')" v-if="cache_announcement_id == ''" @click="confirm_to_publish_announcement_dialog = true">
                  Create</v-btn>
                <v-btn color="primary" small :disabled="!valid" v-if="cache_announcement_id != ''"
                       @click="confirm_to_publish_announcement_dialog = true">
                  Publish</v-btn>
                <v-btn flat small @click="resetInput()">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>

      <v-snackbar
          :color="snackBar.color"
          :top="snackBar.top"
          :bottom="snackBar.bottom"
          :left="snackBar.left"
          :right="snackBar.right"
          v-model="snackBar.show"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>


      <v-dialog v-model="confirm_to_publish_announcement_dialog" scrollable :overlay="false" max-width="450px"
                transition="dialog-transition" persistent>
        <v-card>
          <v-card-title primary-title>
            <v-flex xs12 md12>
              <label class="heading"><b>Title : </b></label>
              <span>{{ cache_announcement_title}}</span>
            </v-flex>
            <br>
            <v-flex xs12 md12 style="margin-top: 5px;">
              <label class="heading"><b>Description : </b></label>
              <span>{{ cache_announcement_description}}</span>
            </v-flex>

            <v-flex xs12 md12><br /></v-flex>

            <span class="subheading">Do you want to publish this announcement ?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small @click="confirm_to_publish_announcement_dialog = false">No</v-btn>
            <v-btn small color="primary" type="submit" @click="createAnnouncement()"
                   :loading="confirm_button_loader">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog v-model="publish_message_dialog" scrollable :overlay="false" max-width="450px"
                transition="dialog-transition" persistent>
        <v-card>
          <v-card-title primary-title>
            <span class="subheading">{{ publish_message }}</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="resetInput()">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-layout row justify-center>
        <v-dialog :overlay="false"
                  v-model="dialog2" fullscreen class="text-xs-center"
        >
          <div class="text-xs-center">
          <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="#ff9233"
                class="text-xs-center my-5"
                large
                v-if="submit_attachment_loader"
            ></v-progress-circular>
          </div>
        </v-dialog>
      </v-layout>
    </v-container>
    </v-layout>
  </div>
</template>
<script>
import moment from "moment";
import {VueEditor} from "vue2-editor";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';


export default {
  created() {
  },
  computed: {
    // workspaceRequestCode:function(){
    //  return this.announcement_object.office_id.name + '/'+ this.announcement_object.tower_id.name + '/' + this.announcement_object.wing_id.name +'/'+this.announcement_object.type+'/'+this.announcement_object.number;
    // }
  },

  components: {
    VueEditor,
    flatPickr
  },
  watch: {

    "announcement_object.show_till": {
      handler(val) {
        // if(val){
        //   this.announcement_object.show_till.set("minDate", val);
        // }
        if (val && (this.announcement_object.type.id == 2 || this.announcement_object.type.id == 4 || this.announcement_object.type.id == 5)) {
          this.announcement_object.relevant_to = val;
          this.announcement_object.date = moment(val).format('YYYY-MM-DD');
        }

      }
    },
    "announcement_object.train_code": {
      handler() {
        this.announcement_object.local_line = '';
        this.announcement_object.title = '';
        this.announcement_object.description = '';
        if (this.announcement_object.type.id == 1 || this.announcement_object.type.id == 5) {
          if (this.announcement_object.train_code != '') {
            this.is_populate = true;
          }
        }
      }
    },
    "announcement_object.delay_time": {
      handler(e) {
        if (this.announcement_object.type.id == 3) {
          if (this.announcement_object.train_code != '' && this.announcement_object.delay_time.length >= 1) {
            this.is_populate = true;
          } else {
            this.is_populate = false;
          }
        }
      }
    },
    "announcement_object.type": {
      handler() {
        // this.getTypeList();
        this.announcement_object.train_code = '';
        this.announcement_object.local_line = '';
        this.announcement_object.delay_time = "";
        this.announcement_object.title = '';
        this.announcement_object.description = '';
      }
    },
    "announcement_object.description":{
      handler(val){
        if (this.announcement_object.type.id == 5) {
          this.cache_announcement_description = val;
        }
      }
    },
    "announcement_object.title":{
      handler(val){
        if (this.announcement_object.type.id == 5) {
          this.cache_announcement_title = val;
        }
      }
    },
  },
  methods: {
    resetInput() {
      this.publish_message_dialog = false;
      this.announcement_object.title = "";
      this.announcement_object.local_line = "";
      this.announcement_object.description = "";
      this.announcement_object.type = "";
      this.announcement_object.train_code = "";
      this.announcement_object.delay_time = "";
      this.cache_announcement_id = "";
      this.getLocalLineList();
      this.getTypeList();
      this.getTrainCodes();
      return;
    },
    populate_announcement: function () {
      this.submit_loader = true;
      const announcement_type_id = this.announcement_object.type.id;
      const train_code_id = this.announcement_object.train_code;
      let new_announcement = Object.assign({}, this.announcement_object);
      new_announcement.announcement_type_id = this.announcement_object.type.id;
      new_announcement.train_code_id = this.announcement_object.train_code;
      new_announcement.delay_time = this.announcement_object.delay_time;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/announcement-template`, new_announcement, {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {

              this.announcement_object.title = response.data.title;
              this.announcement_object.description = response.data.description;

              this.cache_announcement_title = response.data.title;
              this.cache_announcement_description = response.data.description;
              // if(this.announcement_object.type.id == 5){
              //   this.announcement_object.title = '';
              //   this.announcement_object.description = '';
              //
              //   this.cache_announcement_title = '';
              //   this.cache_announcement_description = '';
              // }


              this.announcement_object.local_line = response.data.local_line;
              if (this.announcement_object.type.id == 1 || this.announcement_object.type.id == 3) {
                this.announcement_object.relevant_from = response.data.start;
                this.announcement_object.relevant_to = response.data.last;
              }
              this.submit_loader = false;
            }

          }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.submit_loader = false;
      });
    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {

          this[scope]();
        }
      });
    },
    createAnnouncement: function () {
      // this.submit_loader = true;
      // this.dialog2 = true;
      // this.submit_attachment_loader = true;
      this.confirm_button_loader = true;

      let new_announcement = Object.assign({}, this.announcement_object);
      new_announcement.title = this.announcement_object.title;
      new_announcement.description = this.announcement_object.description;
      new_announcement.pin_till = this.announcement_object.date;
      new_announcement.type = this.announcement_object.type.id;
      new_announcement.local_line = this.announcement_object.local_line;
      new_announcement.body = this.announcement_object.body;
      // new_announcement.is_notify = this.announcement_object.is_notify;
      // new_announcement.ext_link = this.announcement_object.ext_link;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/add-announcement`, new_announcement).then((response) => {
        if (response.data.status == 1) {
          this.dialog2 = false;
          // this.submit_attachment_loader = false;
          this.announcement_id = response.data.announcement.id;
          this.cache_announcement_id = response.data.announcement.id;
          var announcement = response.data.announcement;
          this.updateStatus();
          this.submit_loader = false;

        } else if (response.data.status == 2) {
          this.dialog2 = false;
          this.submit_attachment_loader = false;
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
          this.$validator.reset();
        } else {
          this.dialog2 = false;
          this.submit_attachment_loader = false;
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
        }

      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.dialog2 = false;
        this.submit_attachment_loader = false;
      });

    },
    getTypeList: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/wa-announcer/announcement-types`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.announcement_types = response.data.types;
              this.announcement_object.type = this.announcement_types[0];
            }

          })
    },
    getTrainCodes: function () {
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/train-codes`,
          {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.train_codes = response.data.train_codes;
            }

          })

    },
    getLocalLineList: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/local-lines`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.local_lines = response.data.local_lines;
            }

          })
    },
    updateStatus: function () {
      this.confirm_button_loader = true;
      this.announcement_status = "Publish";
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/change-status`, {
        announcement_id: this.announcement_id,
        status: this.announcement_status
      }, {headers: this.$headers}).then((response) => {

        if (response.data.status == 1) {
          this.updateStatusNotify();
          // this.confirm_to_publish_announcement_dialog = false;
          // this.confirm_button_loader = false;
          // this.response_message = response.data.message;
          // this.response_status = response.data.status;
          // this.status_model = false;
          // this.publish_message = response.data.message;
          // this.publish_message_dialog = true;
          // this.snackBar.message = response.data.message;
          // this.snackBar.show = true;
        }
        if (response.data.status == 2) {
          this.response_message = response.data.message;
          this.response_status = response.data.status;
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
        }

      }).catch((error) => {

      }).finally(() => {

      });
    },
    updateStatusNotify: function () {
      this.confirm_button_loader = true;
      this.announcement_status = "Notify";
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/change-status`, {
        announcement_id: this.announcement_id,
        status: this.announcement_status
      }, {headers: this.$headers}).then((response) => {

        if (response.data.status == 1) {
          this.confirm_to_publish_announcement_dialog = false;
          this.confirm_button_loader = false;
          this.response_message = response.data.message;
          this.response_status = response.data.status;
          this.status_model = false;
          this.publish_message = response.data.message;
          this.publish_message_dialog = true;
          // this.snackBar.message = response.data.message;
          // this.snackBar.show = true;
        }

      }).catch((error) => {

      }).finally(() => {

      });
    },
    getItemText(item) {
      return `${item.number} - ${item.short_code}`;
    }
  },
  data: () => {
    return {
      show_search: true,
      config: {
        enableTime: true,
        altInput: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: false,
        minDate: moment().format('YYYY-MM-DD'),
      },
      config1: {
        enableTime: false,
        altInput: true,
        dateFormat: "Y-m-d",
        time_24hr: false,
        minDate: moment().format('YYYY-MM-DD'),
      },
      announcement_object: {
        local_line: [],
        title: "",
        type: "",
        train_code: "",
        description: "",
        body: "",
        ext_link: "",
        delay_time: "",
        is_notify: false,
        show_in_search: true,
      },
      is_populate: false,
      submit_loader: false,
      valid: false,
      title_content: '',
      description_content: '',
      floor_list: [],
      announcement_types: [],
      train_codes: [],
      local_lines: [],
      tower_list: [],
      wing_list: [],
      auth_user: {
        roles: [{}]
      },
      workspaceRequestCode: "",
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false
      },
      confirm_to_publish_announcement: '',
      confirm_to_publish_announcement_dialog: false,
      announcement_status: '',
      announcement_id: '',
      cache_announcement_title: '',
      cache_announcement_description: '',
      publish_message_dialog: false,
      publish_message: '',
      confirm_button_loader: false,
      cache_announcement_id: '',
      dialog2 : false,
      submit_attachment_loader : false
    }
  },

  mounted() {
    this.cache_announcement_id = '';
    this.getLocalLineList();
    this.getTypeList();
    this.getTrainCodes();
  },

};
</script>
<style>
.v-dialog--fullscreen{
  background-color: rgba(132, 130, 129, 0.3) !important;
}
</style>
